/* eslint-disable @typescript-eslint/no-unused-expressions */
// @ts-nocheck
import { call, put, takeLatest, select } from 'redux-saga/effects';
import { errorToast, infoToast, successToast } from 'utils/toastHandler';
import {
  createTemplate,
  getTemplates,
  getTemplate,
  updateTemplate,
  deleteTemplate,
  cloneTemplate,
  createResourceCode,
  getResourceCodes,
  updateResourceCode,
  forceUpdateResourceCode,
  deleteResourceCode,
  createNote,
  updateNote,
  deleteNote,
  addDyanmicField,
  getResourceType,
} from '../services/resource_code';
import resourceCodeActions, { Types } from '../actions/resource_code';
import resourceCodeImportActions from '../actions/resource_code_import';
import { Logger } from 'utils/logger';

const getDynamicFieldFormFields = (state) =>
  state.global.resourceCode.dynamicFieldFormFields;

function* createTemplateRequest(action) {
  try {
    const { payload } = action;
    const response = yield call(createTemplate, payload);

    yield put(
      resourceCodeActions.createTemplateSuccess({
        data: response.data,
      }),
    );
    successToast('Data Created Successfully');
    yield put(resourceCodeActions.closeTemplateDrawer());
    yield put(resourceCodeActions.resetTemplateFormFields());
    yield put(resourceCodeActions.setLatestTemplateId(response.data));
    yield put(resourceCodeActions.openActionOptionDrawer());
  } catch (error) {
    yield put(resourceCodeActions.createTemplateFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* getTemplatesRequest(action) {
  try {
    const { params } = action;
    const response = yield call(getTemplates, params);
    yield put(resourceCodeActions.getTemplatesSuccess(response.data));
  } catch (error) {
    Logger.error({
      message: 'Error getting templates',
      data: error,
    });
    yield put(resourceCodeActions.getTemplatesFailure());
  }
}

function* getTemplateRequest(action) {
  try {
    const { params } = action;
    const response = yield call(getTemplate, params);
    yield put(resourceCodeActions.getTemplateSuccess({ data: response.data }));
  } catch (error) {
    Logger.error({
      message: 'Error getting template',
      data: error,
    });
    yield put(resourceCodeActions.getTemplateFailure());
  }
}

function* updateTemplateRequest(action) {
  try {
    const { params, payload } = action;
    const response = yield call(updateTemplate, params, payload);
    yield put(
      resourceCodeActions.updateTemplateSuccess({ data: response.data }),
    );
    successToast('Data Updated Successfully');
    yield put(resourceCodeActions.closeTemplateDrawer());
    yield put(resourceCodeActions.resetFormFields());
  } catch (error) {
    yield put(resourceCodeActions.updateTemplateFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* deleteTemplateRequest(action) {
  try {
    const { params } = action;

    yield call(deleteTemplate, params);
    yield put(resourceCodeActions.deleteTemplateSuccess());
    yield put(resourceCodeActions.closeTemplateConfirmationModal());
    yield put(resourceCodeActions.getTemplatesRequest(params));
    successToast('Data deleted successfully');
  } catch (error) {
    yield put(resourceCodeActions.deleteTemplateFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
    yield put(resourceCodeActions.closeTemplateConfirmationModal());
  }
}

function* cloneTemplateRequest(action) {
  try {
    const { params } = action;
    const response = yield call(cloneTemplate, params);
    yield put(
      resourceCodeActions.cloneTemplateSuccess({ data: response.data }),
    );
    infoToast('Resource code list has been cloned successfully.');
  } catch (error) {
    yield put(resourceCodeActions.cloneTemplateFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* createResourceCodeRequest(action) {
  try {
    const { payload, data } = action;
    const response = yield call(createResourceCode, payload);
    yield put(
      resourceCodeActions.createResourceCodeSuccess({
        data: response.data,
      }),
    );
    if (!data.shouldCreateAnother) {
      yield put(resourceCodeActions.closeResourceCodeDrawer());
    }
    yield put(resourceCodeActions.resetResourceCodeFormFields());
    successToast('Resource Code created successfully');
  } catch (error) {
    yield put(resourceCodeActions.createResourceCodeFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* getResourceCodesRequest(action) {
  try {
    const { params } = action;
    const response = yield call(getResourceCodes, params);
    yield put(resourceCodeActions.getResourceCodesSuccess(response.data));
  } catch (error) {
    Logger.error({
      message: 'Error getting resource codes',
      data: error,
    });
    yield put(resourceCodeActions.getResourceCodesFailure());
  }
}

function* updateResourceCodeRequest(action) {
  try {
    const { params, payload } = action;
    const response = yield call(updateResourceCode, params, payload);
    if (
      response.status === 200 ||
      response.status === 201 ||
      response.staus < 300
    ) {
      yield put(
        resourceCodeActions.updateResourceCodeSuccess({ data: response.data }),
      );
      yield put(resourceCodeActions.closeResourceCodeDrawer());
      yield put(resourceCodeActions.resetResourceCodeFormFields());
      successToast('Resource Code updated successfully');
    } else if (response.status === 428) {
      yield put(resourceCodeActions.openAlertModal(response.data));
    } else if (response.status === 400) {
      yield put(resourceCodeActions.updateResourceCodeFailure());
      response?.data?.error && errorToast(response?.data?.error);
      yield put(resourceCodeActions.closeResourceCodeDrawer());
      yield put(resourceCodeActions.resetResourceCodeFormFields());
      // yield put(resourceCodeActions.openAlertModal(response.data));
    } else {
      response?.data?.error && errorToast(response?.data?.error);
      yield put(resourceCodeActions.closeResourceCodeDrawer());
      yield put(resourceCodeActions.resetResourceCodeFormFields());
    }
  } catch (error) {
    yield put(resourceCodeActions.updateResourceCodeFailure(error));
    error?.response?.data?.error && errorToast(response?.data?.error);
  }
}

function* forceUpdateResourceCodeRequest(action) {
  try {
    const { params, payload } = action;
    const response = yield call(forceUpdateResourceCode, params, payload);
    yield put(
      resourceCodeActions.updateResourceCodeSuccess({ data: response.data }),
    );
    yield put(resourceCodeActions.closeResourceCodeDrawer());
    yield put(resourceCodeActions.closeAlertModal());
    yield put(resourceCodeActions.resetResourceCodeFormFields());
    successToast('Resource Code updated successfully');
  } catch (error) {
    yield put(resourceCodeActions.updateResourceCodeFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* deleteResourceCodeRequest(action) {
  try {
    const { params } = action;
    yield call(deleteResourceCode, params);
    yield put(resourceCodeActions.deleteResourceCodeSuccess());
    yield put(resourceCodeActions.closeConfirmationModal());
    successToast('Resource Code deleted successfully');
  } catch (error) {
    yield put(resourceCodeActions.deleteResourceCodeFailure());

    error?.response?.data?.error && errorToast(error.response.data.error);

    yield put(resourceCodeActions.closeConfirmationModal());
  }
}

function* createNoteRequest(action) {
  try {
    const { payload } = action;
    const response = yield call(createNote, payload);

    yield put(resourceCodeActions.createNoteSuccess({ data: response.data }));
    yield put(resourceCodeActions.closeNoteModal());
    successToast('Note added successfully');
  } catch (error) {
    yield put(resourceCodeActions.createNoteFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* updateNoteRequest(action) {
  try {
    const { params, payload } = action;
    const response = yield call(updateNote, params, payload);

    yield put(resourceCodeActions.updateNoteSuccess({ data: response.data }));
    yield put(resourceCodeActions.closeNoteModal());
    successToast('Note updated successfully');
  } catch (error) {
    yield put(resourceCodeActions.updateNoteFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* deleteNoteRequest(action) {
  try {
    const { params } = action;
    yield call(deleteNote, params);
    yield put(resourceCodeActions.deleteNoteSuccess(params));
    successToast('Note Deleted successfully');
  } catch (error) {
    yield put(resourceCodeActions.deleteNoteFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* addDynamicFieldRequest(action) {
  try {
    const { params, payload, data } = action;

    const response = yield call(addDyanmicField, params, payload);

    yield put(
      resourceCodeActions.addDynamicFieldSuccess({ data: response.data }),
    );

    if (data?.isFromUpdate) {
      yield put(resourceCodeActions.closeDynamicFieldDrawer());
      successToast('Text field updated successfully');
    }

    if (data.fromImportPage) {
      const dynamicFieldFormFields = yield select(getDynamicFieldFormFields);
      yield put(
        resourceCodeImportActions.addSystemField(dynamicFieldFormFields),
      );
    }

    yield put(resourceCodeActions.closeDynamicFieldDrawer());
    successToast('Text field added successfully');
  } catch (error) {
    yield put(resourceCodeActions.addDynamicFieldFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* deleteDynamicFieldRequest(action) {
  try {
    const { params, payload } = action;
    const response = yield call(addDyanmicField, params, payload);
    yield put(
      resourceCodeActions.deleteDynamicFieldSuccess({ data: response.data }),
    );
    yield put(resourceCodeActions.closeDynamicFieldConfirmationModal());
    successToast('Text field deleted successfully');
  } catch (error) {
    yield put(resourceCodeActions.addDynamicFieldFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* getResourceTypeRequest(action) {
  try {
    const { params } = action;
    const response = yield call(getResourceType, params);
    yield put(resourceCodeActions.getResourceTypeSuccess(response.data));
  } catch (error) {
    Logger.error({
      message: 'Error getting resource type',
      data: error,
    });
    yield put(resourceCodeActions.getResourceTypeFailure());
  }
}

function* resourceCodeWatcher() {
  yield takeLatest(Types.CREATE_TEMPLATE_REQUEST, createTemplateRequest);
  yield takeLatest(Types.GET_TEMPLATES_REQUEST, getTemplatesRequest);
  yield takeLatest(Types.GET_TEMPLATE_REQUEST, getTemplateRequest);
  yield takeLatest(Types.UPDATE_TEMPLATE_REQUEST, updateTemplateRequest);
  yield takeLatest(Types.DELETE_TEMPLATE_REQUEST, deleteTemplateRequest);
  yield takeLatest(Types.CLONE_TEMPLATE_REQUEST, cloneTemplateRequest);
  yield takeLatest(
    Types.CREATE_RESOURCE_CODE_REQUEST,
    createResourceCodeRequest,
  );
  yield takeLatest(Types.GET_RESOURCE_CODES_REQUEST, getResourceCodesRequest);
  yield takeLatest(
    Types.UPDATE_RESOURCE_CODE_REQUEST,
    updateResourceCodeRequest,
  );
  yield takeLatest(
    Types.FORCE_UPDATE_RESOURCE_CODE_REQUEST,
    forceUpdateResourceCodeRequest,
  );
  yield takeLatest(
    Types.DELETE_RESOURCE_CODE_REQUEST,
    deleteResourceCodeRequest,
  );
  yield takeLatest(Types.CREATE_NOTE_REQUEST, createNoteRequest);
  yield takeLatest(Types.UPDATE_NOTE_REQUEST, updateNoteRequest);
  yield takeLatest(Types.DELETE_NOTE_REQUEST, deleteNoteRequest);
  yield takeLatest(Types.ADD_DYNAMIC_FIELD_REQUEST, addDynamicFieldRequest);
  yield takeLatest(
    Types.DELETE_DYNAMIC_FIELD_REQUEST,
    deleteDynamicFieldRequest,
  );
  yield takeLatest(Types.GET_RESOURCE_TYPE_REQUEST, getResourceTypeRequest);
}

export default resourceCodeWatcher;
